import { useWebAppGetPersonsById, WebAppPersonDto } from '@mi-front/api-v2';
import { PERSON_QUERY_STALE_TIME_MS } from '../person-constants';

/**
 * Resolves a single person by id from the React Query cache warmed by
 * `usePersonsByIds`. Cache-only (no individual GET) so parallel single-gets
 * cannot race and overwrite batch results — which previously left only one
 * person visible while batch-get had returned several.
 *
 * - `undefined`: no id yet, or batch has not written this key (still loading / never requested)
 * - `null`: batch completed and this id was not returned (confirmed missing)
 * - DTO: person found in cache
 */
export function usePerson(
  personId: string | undefined | null,
): WebAppPersonDto | null | undefined {
  const { data } = useWebAppGetPersonsById(personId ?? '', {
    query: {
      // Subscribe to cache updates from batch-get; do not fetch.
      enabled: false,
      staleTime: PERSON_QUERY_STALE_TIME_MS,
      retry: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  });

  if (!personId) {
    return undefined;
  }

  return data as WebAppPersonDto | null | undefined;
}
